module.exports = __webpack_public_path__ + "static/media/8.8b056a6f.png";